export enum LayoutModeEnum {
  Light = 'light',
  Dark = 'dark',
}
